import { createServiceStore } from 'common/store';
import { INITIAL_STATE } from './constants';
export var useSupervisorStore = createServiceStore({
    initialValues: INITIAL_STATE,
});
